<template>
  <a-card title="设备配置">
    <template  #extra>
        <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
          <template  #btn>
              <a-form-item>
              <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增 </a-button>
            </a-form-item>
          </template>
        </lanseed-form-only>
    </template>
    <a-table :dataSource="dataSource" :pagination="false"
    :loading="loading" :columns="columns">
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'DataSide'">
        {{  AutoData.FindName(datamodel,'DataSide',record.DataSide) }}
      </template>
      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button v-if="auth.edit"  size="small" type="primary" @click="edit(record,index)">
                <EditOutlined /> 修改
            </a-button>
            <a-button  v-if="auth.del&&record.DataSide !=1"  size="small" type="primary" @click="del(record,index)">
                <DeleteOutlined /> 删除
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  </a-card>
</template>
<script setup lang="ts">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined} from '@ant-design/icons-vue'
import { useRoute } from 'vue-router'
import {DefaultRule} from '@/router/types'
import { AutoData } from '@/utils/util'

  const props=defineProps({
    DeviceId:{type:Number,required:true},
    auth:{type:Object,default:()=>{return {see:1,creating:1,edit:1,del:1,agent:0}}}
  })
  const datamodel=ref<any>()//原始数据类型
  onMounted(()=>{
    api.deviceconf.model().then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['DeviceConfigName','DataSide','Description','EnumInfo','Value'])
        var role=AutoData.GetFormModel(datamodel.value,['DeviceConfigName','Description','Value'])
        role.DeviceConfigName.required=true
        formRole.value=role
        getList()
      }
    })
  })

const searchVal:Record=ref({
  keyword:'',
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.deviceconf.list({ pageFlag:false,DeviceId:props.DeviceId,...searchVal}).then(res => {
        loading.value=false
        dataSource.value=res.data
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

const formModel:Record=ref({})
const formRole=ref({})
const formshow=ref<Boolean>(false)
const add=()=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,{DeviceId:props.DeviceId,ID:0,Value:'',DataSide:2})
  formshow.value=true
}
const edit=(d)=>{
  let fm=AutoData.GetDefaltModel(datamodel.value,d)
  //因为值有的是服务器端指定的可选值
        if(d.EnumInfo){
          var ds=JSON.parse(d.EnumInfo)
          if(typeof(ds)=='object'){
            var ar=[]
            for(var k in ds){
              ar.push({name:ds[k],value:k})
            }
            formRole.value.Value.data=ar
            formRole.value.Value.domtype='select'
          }
          console.info(formRole.value)
        }else{
          formRole.value.Value.data=[]
          formRole.value.Value.domtype='input'
        }
  formModel.value=fm
  formshow.value=true
}
const del=(d,i)=>{
  api.deviceconf.del(d.ID).then(res=>{
    if(res.state==1){
       dataSource.value.splice(i,1)
    }
  })
}
const submit=(e:any)=>{
  api.deviceconf.add(e).then(res=>{
    if(res.state==1){
      getList()
      formshow.value=false
    }
  })
}
</script>
